import styled from 'styled-components'

export const ResponsiveContainer = styled.div`
  @media (max-width: 767px) {
    width: 100%;
  }
`

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 767px) {
    flex-direction: column;
    gap: 1.5rem;
  }
`

export const LegendContainer = styled.div`
  position: relative;
  right: 5rem;
  bottom: 3rem;
  align-self: flex-end;

  display: flex;
  flex-direction: column;
  row-gap: 7px;

  @media (max-width: 999px) {
    right: 2rem;
    bottom: 2rem;
  }

  @media (max-width: 767px) {
    inset: unset;
    align-self: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 30px;
  }
`
